import gql from 'graphql-tag';

const DELETE_QR = gql`
    mutation deleteQr ($qr: String!) {
        deleteQr(qr: $qr) {
            internalCode,
            message
        }
    }
`;

export default DELETE_QR;
